import FlagCh from '../assets/img/flag-ch.svg'
import FlagEu from '../assets/img/flag-eu.svg'
import FlagUs from '../assets/img/flag-us.svg'

const Currencies = {ch: {name: 'chf', image: FlagCh}, eu: {name: 'eur', image: FlagEu}, us: {name: 'usd', image: FlagUs}}

export default Currencies;
